/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：1446
 */

var r = require(/* 479 */"../../../../../../253/2583/2584/479")
module.exports = function (e) {
  return e === e && !r(e)
}
